export enum EntryType {
  RequestRead = 0,
  RequestWrite = 1,
  ReadGranted = 2,
  WriteGranted = 3,
  ReadReleased = 4,
  WriteReleased = 5,
  RequestRejected = 6,
  DeadlockDetected = 7,
  DeadlockResolved = 8,
  Unlocked = 9,
  Created = 10,
  DebugInfo = 11,
  PhaseEnded = 12,
}
